import { FiMonitor, FiServer, FiShield, FiZap, FiGlobe, FiTrendingUp, FiSettings, FiLayout } from "react-icons/fi";
import {
  LuSettings,
  LuUsers,
  LuSmartphone,
  LuShieldCheck,
  LuPercent,
  LuShield,
  LuBuilding2,
  LuShoppingBag,
  LuClock,
  LuWallet,
  LuCpu,
  LuClipboardList,
  LuPalette,
  LuCode,
  LuBug,
  LuRocket,
} from "react-icons/lu";

export const webAppBenefits = [
  {
    icon: <FiShield className="w-8 h-8" />,
    title: "High Performance",
    desc: "We build web solutions optimized for speed and reliability, ensuring a smooth user experience across all browsers.",
  },
  {
    icon: <FiZap className="w-8 h-8" />,
    title: "Agile Development",
    desc: "Our agile approach ensures rapid delivery and the flexibility to adapt to changing requirements throughout the project.",
  },
  {
    icon: <FiGlobe className="w-8 h-8" />,
    title: "Global Scalability",
    desc: "Designed for growth, our web architectures handle traffic spikes effortlessly as your business expands worldwide.",
  },
  // {
  //   icon: <FiTrendingUp className="w-8 h-8" />,
  //   title: "Bespoke Solutions",
  //   desc: "Every line of code is tailored to your unique business needs, maximizing your online reach and performance.",
  // },
];

export const webAppServices = [
  {
    icon: <FiMonitor size={36} />,
    title: "Frontend Web Development",
    description: "Build responsive and interactive web interfaces focused on seamless user experiences.",
    image: "/images/WebAppDevelopment/Front_end_development.png",
    link: "/frontend-app-development-services-india",
    points: ["HTML, CSS & JavaScript Development", "Responsive Web Design", "UI/UX Implementation", "Single Page Applications", "Progressive Web Apps"],
  },
  {
    icon: <FiServer size={36} />,
    title: "Backend Web Development",
    description: "Develop secure and scalable backend systems for smooth application performance.",
    image: "/images/WebAppDevelopment/backend_Developement.png",
    link: "/backend-app-development-services-india",
    points: ["Node.js, Python & PHP Development", "RESTful API Development", "Database Management", "Authentication & Security", "Scalable Backend Architecture"],
  },
];

export const webAppProcessSteps = [
  {
    step: "01",
    title: "Consultation & Discovery",
    description: "Understanding your business goals, target audience, and specific requirements to create a clear roadmap.",
    points: ["Requirements gathering", "Feasibility study", "Project scoping"],
  },
  {
    step: "02",
    title: "Research & Strategy",
    description: "Developing a strategic plan tailored to your industry to ensure competitive advantages.",
    points: ["Competitor analysis", "Tech stack selection", "Roadmap definition"],
  },
  {
    step: "03",
    title: "UI/UX & Wireframing",
    description: "Designing intuitive and visually stunning interfaces that enhance user engagement and conversion.",
    points: ["User flow mapping", "Wireframing", "Prototype design"],
  },
  {
    step: "04",
    title: "Custom Development",
    description: "Building robust architectures with clean code following industry best practices for performance and security.",
    points: ["Agile coding", "API integration", "Feature implementation"],
  },
  {
    step: "05",
    title: "Content & Optimization",
    description: "Integrating your content and fine-tuning performance for speed, security, and SEO readiness.",
    points: ["Performance tuning", "SEO integration", "QA testing"],
  },
  {
    step: "06",
    title: "Launch & Deployment",
    description: "Seamlessly deploying your solution to the cloud and providing ongoing support and monitoring.",
    points: ["Server setup", "Go-live support", "Maintenance planning"],
  },
];

export const webAppFaqs = [
  {
    q: "Why should I invest in website development in India for my business?",
    a: "Website development in India offers cost-effective solutions with access to skilled developers who create responsive, modern, and user-friendly websites. Indian companies can build websites for businesses of all sizes, helping you reach a wider audience online.",
  },
  {
    q: "What services does a website development company in India provide?",
    a: "A website development company in India provides end-to-end services including custom website design, eCommerce development, CMS integration, website maintenance, SEO-friendly design, and performance optimization. They ensure your website meets your business goals.",
  },
  {
    q: "How do I choose the best website development company in India?",
    a: "Look for a company with a strong portfolio, positive client reviews, expertise in modern technologies, and transparent communication. The best companies also offer post-launch support and ensure your website is fast, secure, and mobile-friendly.",
  },
  {
    q: "What can I expect from website development services in Delhi/NCR?",
    a: "Companies in Delhi/NCR offer comprehensive services including custom website design, responsive development, eCommerce solutions, CMS-based websites, and SEO-friendly architecture. Local developers provide personalized support and understand the regional market needs.",
  },
];

export const webAppHeroData = {
  backgroundImage: "/images/services/website/web_hero_img.webp",
  whiteImage: "/images/serviceBanners/webAppW.webp",
  subTitle: "We Build Scalable Web Applications",
  title: (
    <>
      Modern <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Web Applications </span> & Digital Experiences
    </>
  ),
  description:
    "We develop fast, scalable, and responsive web applications that enhance user experience, streamline business operations, and strengthen digital presence with modern technologies and performance driven architecture for sustainable growth.",
  primaryButton: {
    title: "Get Started",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Fast & Scalable Performance",
      desc: "Built for speed, smooth performance, and scalable web experiences.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Fully Responsive Design",
      desc: "Optimized for seamless performance across all devices and screen sizes.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure Web Architecture",
      desc: "Developed with modern security standards and reliable scalability.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "User-Focused Development",
      desc: "Clean, intuitive, and user-friendly web application experiences.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "6%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "14%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/python.svg",
      top: "20%",
      right: "20%",
      containerSize: 60,
      iconSize: 40,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const FlutterAppHeroData = {
  backgroundImage: "/images/serviceBanners/FlutterBanner_001.webp",
  whiteImage: "/images/serviceBanners/flutterbannerwhite.webp",
  subTitle: "FLUTTER APP DEVELOPMENT",
  title: (
    <>
      Build Beautiful, Fast & <br /> Scalable Apps with <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Flutter</span>
    </>
  ),
  description:
    "We develop high performance Flutter applications using a single codebase to deliver fast, scalable, and visually appealing mobile apps that work seamlessly across both iOS and Android platforms with smooth user experience.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "High Performance",
      desc: "Optimized for speed and best performance.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Responsive Design",
      desc: "Looks perfect on every device and screen size.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure & Reliable",
      desc: "Built with security best practices and scalable.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Clean Code",
      desc: "Clean, maintainable, and developer friendly.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/python.svg",
      top: "20%",
      right: "22%",
      containerSize: 60,
      iconSize: 40,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const flutterStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

export const flutterSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Custom Mobile App Solutions for Every Business Need",
  buildCards: [
    {
      title: "Cross-Platform App Development",
      desc: "Build high-performance applications for Android and iOS using scalable cross-platform technologies.",
      icon: LuSmartphone,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Enterprise Mobile Solutions",
      desc: "Develop enterprise-grade mobile applications focused on scalability, security, and operational efficiency.",
      icon: LuBuilding2,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "E-Commerce App Development",
      desc: "Create feature-rich eCommerce applications with secure transactions and seamless shopping experiences.",
      icon: LuShoppingBag,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand App Solutions",
      desc: "TBuild modern booking, delivery, and service-based mobile applications with real-time functionality.",
      icon: LuClock,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "FinTech App Development",
      desc: "Develop secure fintech applications with advanced features and modern user experiences.",
      icon: LuWallet,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Custom Mobile App Solutions",
      desc: "Tailored mobile applications developed according to your business goals and industry requirements.",
      icon: LuCpu,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Our Mobile App Development Process",
  processTitle: "Our Strategic Mobile App Development Approach",
  processSteps: [
    {
      step: "01",
      title: " Discovery & Consultation",
      description: "We understand your business objectives, target audience, and project requirements to create the right mobile strategy.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: " Strategy & Planning",
      description: "We define features, technology stack, and a clear roadmap for efficient project execution.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "We design modern, intuitive, and user-focused mobile interfaces that enhance engagement.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: " Mobile App Development",
      description: "We develop scalable and high-performance mobile applications with clean and maintainable architecture.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Quality Testing",
      description: "We test app functionality, security, and performance to ensure a seamless user experience.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Deployment & Support",
      description: "We launch your mobile application successfully and provide continuous maintenance and technical support.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "Why Choose Our Mobile App Development Services?",
  benefitsTitle: "Why Businesses Choose Mobile App Development Solutions",
  benefits: [
    "SCross-Platform Compatibility",
    "Faster App Development",
    "Modern User Interface",
    "Smooth App Performance",
    "Efficient Development Workflow",
    "Scalable Mobile Solutions",
    "Cost-Effective Development",
  ],
  logoImage: "/images/serviceBanners/FlutterBanner_001.webp",
  whiteLogoImage: "/images/serviceBanners/flutterbannerwhite.webp",
};

export const flutterPortfolioData = {
  subtitle: "OUR WORK",
  title: "Flutter Apps We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Foodie Express",
      badge: "Food Delivery App",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A fast and intuitive food delivery app with real-time tracking, secure payments & smooth experience.",
      downloads: "100K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "FinMate",
      badge: "FinTech App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A personal finance app to manage expenses, budgets & investments with advanced analytics.",
      downloads: "250K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};

export const flutterTechnologiesData = {
  techTitle: "TECHNOLOGIES WE USE",
  technologies: [
    { name: "Flutter", icon: "Flutter" },
    { name: "Dart", icon: "Dart" },
    { name: "Firebase", icon: "Firebase" },
    { name: "REST API", icon: "RestAPI" },
    { name: "SQLite", icon: "SQLite" },
    { name: "Provider", icon: "Provider" },
    { name: "Bloc", icon: "Bloc" },
  ],
  trustTitle: "TRUSTED BY BUSINESSES WORLDWIDE",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

export const flutterAboutData = [
  {
    title: "Flutter App Development Company for Scalable Mobile Experiences",
    content: (
      <>
        Modern businesses require mobile applications that deliver consistent performance across devices without increasing development complexity. A trusted{" "}
        <b className="text-text-primary font-semibold">flutter app development company</b> helps organizations create scalable mobile solutions that improve customer engagement,
        usability, and operational flexibility. Many businesses struggle with maintaining separate applications for different platforms, which slows updates and increases costs. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, Flutter applications are developed around business objectives, user expectations, and long-term
        scalability to help brands create future-ready mobile experiences.
      </>
    ),
  },
  {
    title: "Cross Platform App Development Services for Better Efficiency",
    content: (
      <>
        Businesses aiming to expand digital reach often need applications that work smoothly across multiple operating systems. Reliable{" "}
        <b className="text-text-primary font-semibold">cross platform app development services</b> help organizations improve accessibility while maintaining consistent experiences
        across devices. Companies investing in <b className="text-text-primary font-semibold">flutter mobile app development</b> often benefit from stronger flexibility because
        applications can adapt more efficiently to evolving customer expectations and business requirements. Tycho Technologies focuses on practical Flutter strategies designed to
        improve usability while supporting long-term digital transformation.
      </>
    ),
  },
  {
    title: "Hire Flutter Developers for Smarter Mobile Solutions",
    content: (
      <>
        Growing businesses require mobile ecosystems that remain adaptable and performance-focused over time. Companies looking to{" "}
        <b className="text-text-primary font-semibold">hire flutter developers</b> often prioritize scalability, maintainability, and faster deployment to support business growth.
        Organizations aiming to strengthen digital accessibility frequently align mobile innovation with{" "}
        <a href="https://tychotechnologies.com/pwa-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          progressive web app development
        </a>{" "}
        to create connected experiences and improve customer interaction across different digital environments.
      </>
    ),
  },
  {
    title: "Why Businesses Choose a Flutter App Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">flutter app development company in india</b> continues to grow as businesses seek cost-effective and
        scalable mobile technologies. Companies investing in <b className="text-text-primary font-semibold">flutter development services india</b> often focus on performance,
        flexibility, and stronger digital experiences for customers. Businesses partnering with Tycho Technologies gain access to customized Flutter strategies designed around
        measurable business goals and technical requirements. Many organizations also strengthen mobile ecosystems through{" "}
        <a href="https://tychotechnologies.com/react-native-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          react native mobile app development
        </a>{" "}
        to support broader accessibility and future-ready digital growth.
      </>
    ),
  },
];

export const webSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Web Application Solutions for Every Business Need",
  buildCards: [
    {
      title: "Enterprise Web Applications",
      desc: "Develop scalable and secure web applications for modern business operations.",
      icon: LuSmartphone,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "E-Commerce Web Solutions",
      desc: "Build feature-rich eCommerce platforms with seamless shopping experiences.",
      icon: LuBuilding2,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "SaaS Web Applications",
      desc: "Create powerful SaaS platforms with scalable architecture and cloud accessibility.",
      icon: LuShoppingBag,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand Web Platforms",
      desc: "Develop booking, delivery, and service-based web applications with real-time functionality.",
      icon: LuClock,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "FinTech Web Solutions",
      desc: "Build secure fintech web applications with advanced features and smooth user experiences.",
      icon: LuWallet,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Custom Web Development Solutions",
      desc: "Tailored web applications designed to match unique business requirements.",
      icon: LuCpu,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Our Proven Web Application Development Process",
  processTitle: "Our Strategic Web Application Development Approach",
  processSteps: [
    {
      step: "01",
      title: "  Discovery & Consultation",
      description: "We understand your business objectives, audience, and web application requirements.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "  Strategy & Planning",
      description: "We define the project features, technology stack, and development roadmap.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "We create modern and user-friendly web interfaces focused on better engagement.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "  Web Development",
      description: "We build scalable and high-performance web applications with clean architecture.",
      icon: LuCode,
    },
    {
      step: "05",
      title: " Testing & Optimization",
      description: "We ensure secure, bug-free, and smooth-performing web solutions.",
      icon: LuBug,
    },
    {
      step: "06",
      title: " Deployment & Maintenance",
      description: "We deploy your web application and provide continuous technical support.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "Why Choose Our Web Application Development Services?",
  benefitsTitle: "Why Web Application Development is the Right Choice",
  benefits: [
    "Scalable & Flexible Web Solutions",
    "Faster Development & Deployment",
    "Responsive User Experience",
    "High-Performance Web Applications",
    "Secure & Reliable Architecture",
    "Easy Maintenance & Scalability",
    "Cost-Effective Development Solutions",
  ],
  logoImage: "/images/services/website/web_hero_img.webp",
  whiteLogoImage: "/images/serviceBanners/webAppW.webp",
};

export const webPortfolioData = {
  subtitle: "OUR WORK",
  title: "Web Apps We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Foodie Express",
      badge: "Food Delivery App",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A fast and intuitive food delivery app with real-time tracking, secure payments & smooth experience.",
      downloads: "100K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "FinMate",
      badge: "FinTech App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A personal finance app to manage expenses, budgets & investments with advanced analytics.",
      downloads: "250K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};

export const webAppAboutData = [
  {
    title: "Advanced Web Applications for Modern Businesses",
    content: (
      <>
        Businesses today require powerful digital platforms that support automation, customer engagement, and long-term scalability. Professional{" "}
        <b className="text-text-primary font-semibold">web app development services</b> help companies create secure and interactive applications tailored to evolving business
        requirements. Modern web technologies allow businesses to improve workflows, enhance accessibility, and deliver seamless digital experiences across industries.
      </>
    ),
  },

  {
    title: "Custom Web Solutions for Business Growth",
    content: (
      <>
        Every organization operates differently, which makes <b className="text-text-primary font-semibold">custom web application development</b> essential for building flexible
        and business-focused platforms. Custom applications provide better control over integrations, functionality, and user experiences while helping companies streamline
        operations and improve efficiency. Businesses looking for highly interactive digital interfaces often work with providers offering{" "}
        <a href="https://tychotechnologies.com/frontend-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          frontend app development services
        </a>{" "}
        to create responsive and engaging web experiences.
      </>
    ),
  },

  {
    title: "Scalable Platforms with Modern Technologies",
    content: (
      <>
        A reliable <b className="text-text-primary font-semibold">web application development company</b> focuses on building scalable solutions that support business expansion and
        operational efficiency. From enterprise portals to advanced management systems, modern web platforms are designed to handle growing traffic and complex workflows without
        affecting usability. Companies also partner with an experienced{" "}
        <a href="https://tychotechnologies.com/reactjs-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          react js development company
        </a>{" "}
        to create fast, dynamic, and component-based web applications for modern users.
      </>
    ),
  },

  {
    title: "Reliable Web Development Services in India",
    content: (
      <>
        The demand for advanced digital platforms continues to grow across industries including healthcare, education, retail, and finance. Businesses searching for scalable online
        solutions frequently choose a trusted <b className="text-text-primary font-semibold">website development company</b> to strengthen their digital presence and improve
        customer accessibility. Selecting the right <b className="text-text-primary font-semibold">website development company in india</b> also provides access to experienced
        developers and innovative technologies. Many businesses additionally rely on professional{" "}
        <b className="text-text-primary font-semibold">enterprise web development services</b> to build future-ready platforms that support long-term digital growth.
      </>
    ),
  },
];

export const flutterFaqs = [
  {
    q: "Why should I hire Flutter developers in India?",
    a: "Hiring Flutter developers in India gives you access to skilled professionals who can build cross-platform apps quickly and cost-effectively. Indian developers are experienced in creating high-performance, visually appealing apps for both Android and iOS.",
  },
  {
    q: "What do Flutter developers do?",
    a: "Flutter developers design and build mobile apps using Google’s Flutter framework. They focus on creating fast, responsive, and attractive apps that work seamlessly on multiple platforms with a single codebase.",
  },
  {
    q: "What makes a Flutter development company in India stand out?",
    a: "A top Flutter development company in India combines technical expertise, creative design skills, and cost-effective solutions. They deliver high-quality cross-platform apps with smooth performance, regular updates, and excellent post-launch support.",
  },
];
